import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
    selector: 'aira-number',
    templateUrl: './aira-number.component.html',
    styleUrl: './aira-number.component.css',
    standalone: false
})
export class AiraNumberComponent {
  @Input() label;
  @Input() value;
  @Input() prepend = '';
  @Input() append = '';
  @Input() displayFormat = '';
  @Input() previewOnly: boolean = false;

  get displayValue() {
    return this.previewOnly ? magicPreviewDummyData.numberSimple : this.value;
  }
}
